(() => {
  document.querySelectorAll('[data-yiri-coupon]').forEach(ticket => {
    const button = ticket.querySelector('.yiri-coupon__copy');
    if (button.dataset.bound) return;
    button.dataset.bound = 'true';
    const status = ticket.querySelector('.yiri-coupon__status');
    const codeElement = ticket.querySelector('[data-yiri-coupon-code]');
    button.addEventListener('click', async () => {
      const code = codeElement.textContent.trim();
      let copied = false;
      try { await navigator.clipboard.writeText(code); copied = true; } catch (_) {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;opacity:0;width:1px;height:1px;';
        ticket.appendChild(field);
        field.select();
        try { copied = document.execCommand('copy'); } catch (_) {}
        field.remove();
        button.focus({preventScroll:true});
      }
      button.querySelector('span').textContent = copied ? 'Copied!' : 'Copy';
      status.textContent = copied ? 'Code copied. Paste it at checkout.' : 'Select and copy the code above to use it at checkout.';
      if (!copied) {
        const range = document.createRange(); range.selectNodeContents(codeElement);
        const selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range);
      }
    });
  });
})();
